module.exports = __webpack_public_path__ + "img/portraits_07_V.7bc48e43.webp";